import request from "@/utils/request";

export function handleListApi(data) {
    return request({
        url: "/admin/work_log",
        method: "get",
        params: data
    });
}

